import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-82 (BU-10e) — update an existing portal user's role and visibility scope.
 * Proxies through graphql/ to the portal internal admin API (no forecast_db write).
 */
const mutation = graphql`
	mutation updatePortalUserMutation($input: UpdatePortalUserInput!) {
		updatePortalUser(input: $input) {
			portalUsers {
				id
				email
				roleKey
				status
				scopeLevel
				scopeProgrammeIds
				scopeProjectIds
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
